import { css } from '@linaria/atomic';

export const menuItemContainer = css`
  list-style-type: none;
`;

export const tooltipTrigger = css`
  display: inline-flex;
`;

export const button = css`
  display: flex;
  align-items: center;
  height: 24px;
  padding: var(--fabric-number-n-0-px) var(--fabric-number-n-2-px);
  border: none;
  border-radius: var(--fabric-number-n-1-px);
  background-color: var(--fabric-color-neutral-00);
  cursor: pointer;

  &:hover {
    background-color: var(--fabric-color-blue-5);
  }

  &:active {
    background-color: var(--fabric-color-blue-5);
  }
`;

export const buttonOpen = css`
  background-color: var(--fabric-color-blue-5);
`;

export const overflowText = css`
  font-size: inherit;
`;

export const popoverMenu = css`
  width: 220px;
`;

export const menuItemIcon = css`
  flex-shrink: 0;
`;

export const menuItemText = css`
  flex: 1;
  min-width: 0;
`;
